import styled from 'styled-components';
import useAuth from '@sdk/authentication/useAuth';
import Text14 from '@sdk/components/ui/typography/Text14';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import SettingsSwitcherRow from '../SettingsSwitcherRow';
import { useUserOrgSettings } from '../../UserOrgSettingsContext';

export const ShiftFeedback = () => {
  const { currentUser } = useAuth();
  const { userOrgSettings, onUserOrgSettingsChange } = useUserOrgSettings();

  const disabled = !currentUser.isAdmin || !userOrgSettings.clockInEnabled;

  return (
    <>
      <SettingsSwitcherRow
        disabled={!currentUser.isAdmin || !userOrgSettings.clockInEnabled}
        value={userOrgSettings.clockInEnabled && userOrgSettings.shiftFeedbackIsEnabled}
        onChange={(value) => onUserOrgSettingsChange({ shiftFeedbackIsEnabled: value })}
        disabledTip={gettext('Time clock must be enabled to use this feature.')}
        subtitleItem={
          <Text14 themeColor={ThemeColorType.gray} opacity={disabled ? 0.65 : 1}>
            {gettext('Allow employees to give feedback 5 minutes after clocking out of a shift.')}
          </Text14>
        }
      />
      <HorizontalSeparator mTop={20} mBottom={20} />
    </>
  );
};
